import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { SsmlDocument, StoryAtlas } from '@starfox/shared-types';

interface WriterState {
  currentDoc: SsmlDocument | null;
  currentAtlas: StoryAtlas | null;
  streaming: boolean;
}

interface WriterActions {
  setDoc: (d: SsmlDocument | null) => void;
  patchAtlas: (p: Partial<StoryAtlas>) => void;
  setStreaming: (b: boolean) => void;
}

export const useWriterStore = create<WriterState & WriterActions>()(
  immer((set) => ({
    currentDoc: null,
    currentAtlas: null,
    streaming: false,
    setDoc: (d) =>
      set((s) => {
        s.currentDoc = d;
      }),
    patchAtlas: (p) =>
      set((s) => {
        s.currentAtlas = { ...(s.currentAtlas ?? ({} as StoryAtlas)), ...p } as StoryAtlas;
      }),
    setStreaming: (b) =>
      set((s) => {
        s.streaming = b;
      }),
  })),
);
